import { useState } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faBriefcase, faCar, faFileLines, faGraduationCap, faHome, faIdCard, faUser, faUserShield } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";

function Requirements() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [activeTab, setActiveTab] = useState("personal")
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Requirement" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Requirement" icon={<FontAwesomeIcon icon={faFileLines} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <h5 className="fw-bold mb-4 mt-3">Requirements</h5>
            <div className="row">
                <div className="col-12">
                    <div className="mycard mb-3">
                        <div className="d-flex align-items-center">
                            <div className="mytab overflow-x-auto">
                            <div className={`mytab-item text-nowrap ${activeTab === "personal" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("personal")}}><FontAwesomeIcon icon={faUser} style={{fontSize: '14px'}} className="me-1" /> Personal Loan</div>
                            <div className={`mytab-item text-nowrap ${activeTab === "business" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("business")}}><FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-1" /> Business Loan</div>
                            <div className={`mytab-item text-nowrap ${activeTab === "mortgage" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("mortgage")}}><FontAwesomeIcon icon={faHome} style={{fontSize: '14px'}} className="me-1" /> Mortgage</div>
                            <div className={`mytab-item text-nowrap ${activeTab === "student" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("student")}}><FontAwesomeIcon icon={faGraduationCap} style={{fontSize: '14px'}} className="me-1" /> Student Loan</div>
                            <div className={`mytab-item text-nowrap ${activeTab === "auto" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("auto")}}><FontAwesomeIcon icon={faCar} style={{fontSize: '14px'}} className="me-1" /> Auto Loan</div>
                            <div className={`mytab-item text-nowrap ${activeTab === "short" ? 'active' : ''}`} style={{color:'#ff6b35'}} onClick={() => {
                                setActiveTab("short")}}><FontAwesomeIcon icon={faBolt} style={{fontSize: '14px'}} className="me-1" /> Quick/Short-term</div>
                            </div>
                        </div>
                    </div>
                    {activeTab === "personal" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Unsecured loan for individual needs with flexible usage and tenor.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Age 21–65 at time of application</li>
                                        <li>Minimum 6–12 months stable employment or business history</li>
                                        <li>Minimum monthly income threshold as per region</li>
                                        <li>Acceptable credit history and repayment capacity</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Government-issued ID (Passport/ID Card/Driver’s License)</li>
                                        <li>Recent utility bill or bank statement (address proof)</li>
                                        <li>Last 3–6 months bank statements</li>
                                        <li>Latest payslips or income tax returns (where applicable)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Debt consolidation</li>
                                        <li>Home improvements (non-structural)</li>
                                        <li>Medical expenses or emergency funds</li>
                                        <li>Travel or major purchases</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Early repayment options may be available; prepayment charges can apply.</li>
                                        <li>Interest rate varies by credit score and income profile.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "business" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Working capital and expansion financing for SMEs and enterprises.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Business registered and operational for 12–24 months+</li>
                                        <li>Minimum annual turnover threshold as per loan program</li>
                                        <li>Promoter credit standing and business bureau checks</li>
                                        <li>Valid licenses and compliance status</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Business registration/incorporation documents</li>
                                        <li>KYC for owners/directors and shareholding pattern</li>
                                        <li>Last 6–12 months bank statements (business account)</li>
                                        <li>Financials: P&L, Balance Sheet, Tax returns (last 1–2 years)</li>
                                        <li>Invoices, purchase orders or contracts (for working capital)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Working capital and inventory purchase</li>
                                        <li>Equipment/machinery procurement</li>
                                        <li>Branch expansion, marketing and operations scale-up</li>
                                        <li>Invoice financing and cashflow smoothing</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Collateral or guarantees may be required for higher ticket sizes.</li>
                                        <li>Cashflow-based underwriting may be applied for unsecured programs.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "mortgage" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Secured loan for home purchase, construction, or refinance.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Age and income criteria as per policy</li>
                                        <li>Stable employment or business continuity (12–24 months)</li>
                                        <li>Property valuation within acceptable loan-to-value (LTV)</li>
                                        <li>Clear property title and legal due diligence</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Applicant KYC and income proof (payslips/ITR/bank statements)</li>
                                        <li>Sale agreement / property documents / approved plans</li>
                                        <li>Property valuation and legal report (as arranged via lender)</li>
                                        <li>Down payment proof and home insurance (where applicable)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Primary residence purchase</li>
                                        <li>Home construction or extension</li>
                                        <li>Refinancing existing mortgage at better terms</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Processing depends on legal/title verification timelines.</li>
                                        <li>Fixed or floating interest rate options may be available.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "student" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Education financing for tuition, living expenses, and study-related costs.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Offer/Admission letter from recognized institution</li>
                                        <li>Co-applicant/guarantor (parent/guardian) may be required</li>
                                        <li>Academic performance and program eligibility checks</li>
                                        <li>Ability to cover portion of costs or collateral (program-dependent)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Admission letter and fee structure/CoE</li>
                                        <li>KYC for student and co-applicant</li>
                                        <li>Academic transcripts and test scores (if applicable)</li>
                                        <li>Bank statements/income proof of co-applicant</li>
                                        <li>Visa and travel documents (for overseas study)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Tuition and lab fees</li>
                                        <li>Accommodation and living expenses</li>
                                        <li>Books, devices, and learning materials</li>
                                        <li>Exam, visa, and travel fees (for international programs)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Moratorium/interest-only period may apply during study tenure.</li>
                                        <li>Repayment typically begins post-course or post-placement.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "auto" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Secured loan for new or used vehicle purchase.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Age and income eligibility as per program</li>
                                        <li>Minimum down payment contribution (varies with vehicle age/value)</li>
                                        <li>Vehicle valuation and insurance requirement</li>
                                        <li>Acceptable credit and employment continuity</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>KYC and income proof (payslips/ITR/bank statements)</li>
                                        <li>Proforma invoice (new) or RC/valuation report (used vehicle)</li>
                                        <li>Insurance and hypothecation documents</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>New vehicle purchase (car/SUV/EV)</li>
                                        <li>Used vehicle purchase with valuation approval</li>
                                        <li>Refinance of existing auto loan</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Tenor depends on vehicle type and age.</li>
                                        <li>Better rates often available for EVs or employer tie-ups.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === "short" && (
                        <div className="row">
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faFileLines} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <p className="mb-0" style={{fontSize:'14px'}}>Small-ticket, short-tenor credit for urgent needs – fast processing.</p>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faUserShield} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Overview</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Simplified KYC and recent bank statement review</li>
                                        <li>Basic income/transaction history threshold</li>
                                        <li>No severe delinquencies in recent credit history</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faIdCard} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Required Documents</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>KYC documents (ID + address proof)</li>
                                        <li>Last 3 months bank statements</li>
                                        <li>Minimal income proof depending on program</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-lg-6">
                                <div className="mycard mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                        <FontAwesomeIcon icon={faBriefcase} style={{fontSize: '14px'}} className="me-2" />
                                        <p className="mb-0 fw-bold">Allowed Purposes</p>
                                    </div>
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Medical, travel, or urgent expenses</li>
                                        <li>Bill payments and short-term cashflow gaps</li>
                                        <li>Small appliance or gadget purchases</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-12">
                                <div className="mycard mb-3">
                                    <ul style={{fontSize:'14px'}}>
                                        <li>Higher rates than standard loans due to speed and tenure.</li>
                                        <li>Prepayment available; charges may apply based on tenor.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Requirements